import React, { useRef } from 'react'
import { connect } from 'react-redux'
import {
  getValue,
  isModalOpen,
} from '../../store/actions'
import BaseModal from '../BaseModal'
import ButtonPrimary from '../ui/ButtonPrimary'

import ButtonTransparent from '../ui/ButtonTransparent'
import './index.css'

const ModalFilter = props => {
  let valueInput = useRef()
  const handleClick = () => {
    props.getValue(valueInput.current.value)
    props.isModalOpen(!props.open)
  }
  const handleClickButtonSecondary = () => {
    props.isModalOpen(!props.open)
  }
  const onClose=()=>{
    props.isModalOpen(!props.open)
  }
  const body = (
    <div className="info-modal__filter">
      <h2 className="info-modal__title">Filter</h2>
      <div className='info-modal__container'>
        <p className='info-modal__text'> Greater than</p>
        <div className='info-modal__wrapper'>
          <input ref={valueInput} type='number' className='info-modal__input' placeholder='0' />
        </div>
        <p>to be counted</p>
      </div>
    </div>
  )
  const footer = (
    <div className="variance-list-modal__form-group variance-list-modal__controls variance-list-modal__footer">
      <ButtonPrimary name="Apply" onClick={handleClick} />
      <ButtonTransparent name='Cancel' onClick={handleClickButtonSecondary} />
    </div>
  )
  return (
    <BaseModal
      onClose={onClose}
      body={body}
      footer={footer}
    />
  )
}
const mapStateToProps = ({ data: { value, open } }) => ({ value, open })
const mapDispatchToProps = ({ getValue, isModalOpen })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalFilter)




